import React from 'react';

const ReloadContext = React.createContext<{
  reload: (error: Error) => void;
}>({
  reload: window.tokenFunction,
});

export default ReloadContext;
